import { useLazyQuery } from '@apollo/client';
import { GET_CHANNEL_IDEA, Idea } from '@frontend/data-access';
import { MetricTag } from '@frontend/feature-idea-channel';
import { Spin } from 'antd';
import { useEffect } from 'react';
import { IdeaBasics } from './basics';
import IdeaContents from './idea-contents';
/* eslint-disable-next-line */
export interface IdeaChannelDetailProps {
  id: string;
}

export function IdeaChannelDetail({ id }: IdeaChannelDetailProps) {
  const [getIdea, { data, loading }] = useLazyQuery<{
    channelIdea: Idea;
  }>(GET_CHANNEL_IDEA);

  useEffect(() => {
    if (id) {
      getIdea({ variables: { ideaId: id } });
    }
  }, [getIdea, id]);

  if (loading || data === undefined)
    return (
      <div className="p-10 text-center">
        <Spin />
      </div>
    );

  return (
    <div className="relative overflow-hidden max-h-[90vh] space-y-4">
      <MetricTag tag={data?.channelIdea.metricTag} />
      <div className="grid md:grid-cols-3">
        <div className="col-span-2 overflow-auto max-h-[80vh]">
          <IdeaContents ideaId={id} />
        </div>
        <div className="col-span-1 overflow-auto max-h-[80vh]">
          <IdeaBasics ideaId={id} />
        </div>
      </div>
    </div>
  );
}

export default IdeaChannelDetail;
